/**
 * Just a class to fix some BigFarm run time errors
 */

export class DoNotInstantiate {

}
